/**
 * Created by xiejs on 2017/6/8
 */
// import reporter from './reporter';

export function getCookie(name) {
  let cookie = document.cookie,
    cookieName = encodeURIComponent(name) + "=",
    cookieValue = null,
    cookieStart = -1,
    cookieVauleArr = [];

  //处理几个token的情况
  while ((cookieStart = cookie.indexOf(cookieName, cookieStart + 1)) > -1) {
    let cookieEnd = cookie.indexOf(";", cookieStart);
    if (cookieEnd == -1) {
      cookieEnd = cookie.length;
    }
    cookieValue = decodeURIComponent(
      cookie.substring(cookieStart + cookieName.length, cookieEnd)
    );
    cookieVauleArr.push(cookieValue);
  }
  if (name === "token") {
    cookieValue = fixToken(cookieVauleArr);
  }
  return cookieValue || cookieVauleArr[cookieVauleArr.length - 1];
}

//处理几个token的情况
function fixToken(cookieVauleArr) {
  var vaule = "";
  try {
    cookieVauleArr.forEach(function (token, idx) {
      var tokenObj = JSON.parse(atob(token.split(".")[1]));
      if (tokenObj.app && tokenObj.app.indexOf("pandaclass") > -1) {
        vaule = token;
      }
    });
  } catch (e) {
    // {
    //   err: e,
    //     cookie: document.cookie
    // }
    if (process.env.NODE_ENV === "production") {
      // UTIL.sendDINGDING('用户token有问题', [
      //   {
      //     key: 'error',
      //     value: e
      //   }, {
      //     key: 'cookie',
      //     value: document.cookie
      //   }
      // ])
      removeAllCookie();
      location.reload();
    }
  }
  return vaule;
}

// export function getCookie(name) {
// 	let cookieName = encodeURIComponent(name) + '=',
// 		cookieStart = document.cookie.indexOf(cookieName),
// 		cookieValue = null;

// 	if (cookieStart > -1) {
// 		let cookieEnd = document.cookie.indexOf(';', cookieStart);
// 		if (cookieEnd == -1) {
// 			cookieEnd = document.cookie.length;
// 		}
// 		cookieValue = decodeURIComponent(document.cookie.substring(cookieStart +
// 			cookieName.length, cookieEnd))
// 	}
// 	return cookieValue;
// }

export function setCookie(name, value, expires, path, domain, secure) {
  let cookieText = encodeURIComponent(name) + "=" + encodeURIComponent(value);

  if (expires instanceof Date) {
    cookieText += "; expires=" + expires.toGMTString();
  }

  if (path) {
    cookieText += "; path=" + path;
  }

  if (domain) {
    cookieText += "; domain=" + domain;
  }

  if (secure) {
    cookieText += "; secure";
  }
  document.cookie = cookieText;
}

export function unsetCookie(name, path, domain, secure) {
  path = path || window.location.pathname;
  domain = domain || window.location.hostname;
  const source = path.replace(/^\/|\/$/g, "").split("/");
  let pre = ``;
  const paths = source.map((item, index) => {
    pre = `${pre}/${item}`;
    return pre;
  });
  paths.forEach((p) => {
    setCookie(name, "", new Date(0), p, domain, secure);
    setCookie(name, "", new Date(0), p, `.` + domain, secure);
  });
}

export function removeAllCookie() {
  var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
  if (keys) {
    for (var i = keys.length; i--; ) unsetCookie(keys[i]);
  }
}

export function throttle(fn, delay) {
  let timer = null,
    firstTime = true;
  return function () {
    let ctx = this,
      args = arguments;
    if (firstTime) {
      fn.apply(ctx, args);
      return (firstTime = false);
    }
    if (timer) {
      return false;
    }
    timer = setTimeout(function () {
      clearTimeout(timer);
      timer = null;
      fn.apply(ctx, args);
    }, delay);
  };
}

export function debounce(fn, delay) {
  let timer = null;
  return function () {
    let ctx = this;
    let args = arguments;
    if (timer) {
      clearTimeout(timer);
      timer = setTimeout(function () {
        timer = null;
        fn.apply(ctx, args);
      }, delay);
      return false;
    }
    timer = setTimeout(function () {
      timer = null;
      fn.apply(ctx, args);
    }, delay);
  };
}

export function onceInSeconds(fn, interval = 500) {
  let isLock = false;
  return function (...args) {
    if (isLock) return;
    isLock = true;
    fn.apply(this, args);

    setTimeout(() => {
      isLock = false;
    }, interval);
  };
}

export function base64Decode(str) {
  return decodeURIComponent(
    atob(str)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );
}

export function compose(f, g) {
  return function (x) {
    return f(g(x));
  };
}

export function getJWT() {
  /* global DEBUG */
  if (process.env.NODE_ENV == "development") {
    return {
      sub: "adfg",
      pid: 5,
    };
  }
  let token = getCookie("token"),
    payload = "",
    jwt = null;
  if (token) {
    payload = token.split(".")[1];
  }
  try {
    jwt = JSON.parse(base64Decode(payload));
  } catch (e) {
    // reporter.send(e, 'util.js');
  }
  return jwt;
}

//发送给钉钉机器人
export function sendDINGDING(text) {
  const feature = "release hotfix master";
  if (feature.includes(configDeploy.feature)) {
    var http = require("https");

    const host = "oapi.dingtalk.com";
    //我的群
    // const path = "/robot/send?access_token=3ecc66e2ea245fe0a3fa11751905c4a6502d9a96738b095f7566a992827c9819";
    const path =
      "/robot/send?access_token=822cfdc4d86e2b6c17328813b172515fc272beaabb91ead33b775528609051a8";

    const content = {
      msgtype: "markdown",
      markdown: {
        title: configDeploy.feature,
        text: text,
      },
    };

    const options = {
      host: host,
      path: path,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    };

    var req = http.request(options, function (res) {
      console.log("钉钉机器人已发送");
    });

    req.write(JSON.stringify(content));
    req.end();
  }
}

export function check() {
  var length = 0,
    pre = {},
    obj = {};
  return function (a) {
    obj = Object.assign({}, pre, a);
    let size = Object.keys(obj).length;
    length += Object.keys(a).length;
    if (size < length) {
      var target = findKeyInObj(pre, a);
      console.warn(`有重复的api: ${target}`);
      length = size;
    }
    pre = obj;
  };
}

function findKeyInObj(pre, a) {
  var target = "";
  Object.keys(a).some((key) => {
    if (pre.hasOwnProperty(key)) {
      target = key;
      return true;
    }
    return false;
  });
  return target;
}

//恢复刷新页面滚动条停留上次浏览的位置的问题;
export function resetScrollBar() {
  history.scrollRestoration = "manual";
  window.scrollTo(0, 0);
}
//传入组件上下文，解决局部滚动白屏问题
export function scrollPage(vm) {
  vm.$nextTick(() => {
    let dom = document.documentElement;
    if (dom) {
      window.scrollTo(0, dom.scrollTop + 1);
      window.scrollTo(0, dom.scrollTop - 1);
    }
  });
}

export function isIOS() {
  return /iphone/.test(navigator.userAgent.toLowerCase());
}

export function baseFindIndex(
  array,
  predicate,
  fromIndex = 0,
  fromRight = false
) {
  const { length } = array;
  let index = fromIndex + (fromRight ? 1 : -1);

  while (fromRight ? index-- : ++index < length) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

export function pxTorRem(num) {
  return (num.replace("px", "") / 75) * 1 + "rem";
}

export function pxToVw(num) {
  return (num.replace("px", "") / 750) * 100 + "vw";
}

export function chain(arr) {
  return arr.reduce((pre, next) => (...args) => {
    const result = pre.apply(this, args);
    if (!result) {
      return next.apply(this, args);
    }
    return result;
  });
}

//串行同步 从右到左
export function composeRight(arr) {
  return arr.reduce((a, b) => (...args) => a(b(args)));
}

//串行同步 从左到左
export function composeLeft(arr) {
  return arr.reduceRight((a, b) => (...args) => a(b(args)));
}

//异步
export function composeAsync(arr, callback) {
  return arr.reduce((a, b) => () => b(arguments, calback), callback);
}

export function judgeIsPhoneX() {
  return (
    /iphone/gi.test(navigator.userAgent) &&
    screen.height == 812 &&
    screen.width == 375
  );
}

export function checkMobile(mobile) {
  return /^\d{11}$/.test(mobile);
}

export function getPosition() {
  const location = window.location;
  const section = location.pathname.split("/").filter((s) => s.length > 0);
  if (!section.length) {
    console.log("url no have a position!");
  }
  return section.pop();
}



// WEBPACK FOOTER //
// ./src/lib/util.js